import { useNavigate as useReactRouterNavigate } from "react-router-dom"

export function useNavigate() {
  const navigate = useReactRouterNavigate()

  /**
   * @param options.fallback -
   * Use options.fallback to redirect when history stack is empty or just one page
   */
  const back = (options?: { fallback?: string }) => {
    if (options?.fallback && window.history.length <= 2) {
      navigate(options.fallback)
    } else {
      navigate(-1)
    }
  }

  return { navigate, back }
}
